import { apiClient } from "@api/client";
import { request } from "@api/request";
import { toTodayVisit, type TodayVisit } from "@visits/visitsClient";

export const calendarClient = {
  /** Inclusive clinic-local date range. */
  range: (start: string, end: string): Promise<TodayVisit[]> =>
    request(() =>
      apiClient.GET("/visits/scheduled", {
        params: { query: { start, end, include_overlapping: true } },
      }),
    ).then((rows) => rows.map((row) => toTodayVisit(row, null))),
};
